import { cached } from '@porotutu/react'
import { listQueryOf } from '@porotutu/react/paging'
import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { permittedRoute, signedInRoute } from '@/router/root'
import { CRM_EVENT_SORTABLE, EVENT_CATEGORIES } from '../vocabulary'
import { eventQuery, eventsQuery } from './queries'

const eventSearch = (raw: Record<string, unknown>) =>
  listQueryOf(raw, CRM_EVENT_SORTABLE, [], ['customer_id'], { category: EVENT_CATEGORIES })

export const eventsRoute = createRoute({
  getParentRoute: () => signedInRoute,
  beforeLoad: permittedRoute('events'),
  path: '/events',
  validateSearch: eventSearch,
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps }) => context.queryClient.query(cached(eventsQuery(deps))),
  component: lazyRouteComponent(() => import('./pages'), 'EventsPage'),
})

export const eventRoute = createRoute({
  getParentRoute: () => signedInRoute,
  beforeLoad: permittedRoute('events'),
  path: '/events/$id',
  validateSearch: eventSearch,
  loader: ({ context, params }) => context.queryClient.query(cached(eventQuery(params.id))),
  component: lazyRouteComponent(() => import('./pages'), 'EventPage'),
})

export const eventRoutes = [eventsRoute, eventRoute]
